import hu from "../locales/hu.json";
import en from "../locales/en.json";
import de from "../locales/de.json";
import sk from "../locales/sk.json";
import cs from "../locales/cs.json";
import pl from "../locales/pl.json";
import ro from "../locales/ro.json";
import hr from "../locales/hr.json";
import sl from "../locales/sl.json";
import srLatn from "../locales/sr-Latn.json";
import uk from "../locales/uk.json";

export type Messages = Record<string, string>;
export type TranslationKey = keyof typeof hu;

export const RESOURCES: Record<string, Messages> = {
  hu, en, de, sk, cs, pl, ro, hr, sl, "sr-Latn": srLatn, uk,
};
